function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { themeGet } from 'styled-system';
import { Flex, applySizes } from 'pcln-design-system';
var sizes = {
  singleColumn: css(["& > *{width:100%;}"]),
  twoColumns: css(["& > *{width:calc(50% - ", "px);}"], themeGet('space.1'))
};
var MenuContainer = styled(Flex).withConfig({
  displayName: "MenuList__MenuContainer",
  componentId: "sc-enbv9e-0"
})(["font-family:", ";overflow-y:auto;& > *{margin-right:", "px;margin-bottom:", "px;}", ";"], themeGet('font') || "'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif", themeGet('space.1'), themeGet('space.1'), applySizes(sizes));

function focusNext(item) {
  return item === null || item === void 0 ? void 0 : item.nextElementSibling;
}

function focusPrevious(item) {
  return item === null || item === void 0 ? void 0 : item.previousElementSibling;
}

function moveFocus(currentFocus, traversalFunction) {
  var nextFocus = traversalFunction(currentFocus);
  nextFocus === null || nextFocus === void 0 ? void 0 : nextFocus.focus();
}

function MenuList(_ref) {
  var id = _ref.id,
      children = _ref.children,
      color = _ref.color,
      size = _ref.size,
      height = _ref.height,
      handleClose = _ref.handleClose;
  var listRef = useRef(null);
  var currentItemRef = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      currentItemId = _useState2[0],
      setCurrentItemId = _useState2[1];

  useEffect(function () {
    var _currentItemRef$curre, _currentItemRef$curre2;

    setCurrentItemId((_currentItemRef$curre = currentItemRef.current) === null || _currentItemRef$curre === void 0 ? void 0 : _currentItemRef$curre.id);
    (_currentItemRef$curre2 = currentItemRef.current) === null || _currentItemRef$curre2 === void 0 ? void 0 : _currentItemRef$curre2.focus();
  }, []);
  var handleKeyDown = useCallback(function (evt) {
    var _list$ownerDocument;

    var list = listRef.current;
    var key = evt.key;
    var currentFocus = list === null || list === void 0 ? void 0 : (_list$ownerDocument = list.ownerDocument) === null || _list$ownerDocument === void 0 ? void 0 : _list$ownerDocument.activeElement;

    if (key === 'ArrowDown') {
      evt.preventDefault();
      moveFocus(currentFocus, focusNext);
    } else if (key === 'ArrowUp') {
      evt.preventDefault();
      moveFocus(currentFocus, focusPrevious);
    }
  }, []);
  return /*#__PURE__*/React.createElement(MenuContainer, {
    id: id,
    ref: listRef,
    role: "listbox",
    "aria-activedescendant": currentItemId,
    flexWrap: "wrap",
    height: height,
    size: size,
    p: 2,
    pr: 1,
    pb: 1,
    onKeyDown: handleKeyDown
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      id: "option".concat(index),
      ref: child.props.selected ? currentItemRef : null,
      color: child.props.color || color,
      handleClose: handleClose
    });
  }));
}

MenuList.displayName = 'MenuList';
MenuList.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.number,
  handleClose: PropTypes.func
};
MenuList.defaultProps = {
  size: 'singleColumn'
};
export default MenuList;